import React from 'react';
import CustomDropdown from './CustomDropdown';

const GoalProgress = ({
  selectedGoal,
  progressFilters,
  onFilterChange,
  emailOptions,
  statusOptions,
  filteredStudents,
  onBack,
}) => (
  <>
    <button className="back-btn-goal" onClick={onBack}>
      <span aria-hidden="true">&#8592;</span> Back to Goals
    </button>
    <h2 style={{ fontWeight: 700, fontSize: '1.5rem', margin: '1.5rem 0' }}>{selectedGoal.name}</h2>
    <div style={{ color: '#555', marginBottom: '1.5rem' }}>
      Section: <b>{selectedGoal.section}</b> &nbsp; | &nbsp; Course Type: <b>{selectedGoal.courseType}</b>
    </div>
    <div className="filters" style={{ marginBottom: 0 }}>
      <div className="filter-dropdowns" style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <CustomDropdown
          name="email"
          options={emailOptions}
          value={progressFilters.email}
          onChange={onFilterChange}
        />
        <CustomDropdown
          name="status"
          options={statusOptions}
          value={progressFilters.status}
          onChange={onFilterChange}
        />
      </div>
    </div>
    <div className="table-container">
      <table className="classwork-table">
        <thead>
          <tr>
            <th>Student</th>
            <th>Section</th>
            <th>Course Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents.length === 0 ? (
            <tr><td colSpan={4} style={{ textAlign: 'center', color: '#888' }}>No students found for this goal.</td></tr>
          ) : (
            filteredStudents.map(student => (
              <tr key={student.id} className={student.status ? 'completed' : ''}>
                <td data-label="Student">{student.email}</td>
                <td data-label="Section">
                  {student.sectionId.length === 1
                    ? `Section 0${student.sectionId}`
                    : `Section ${student.sectionId}`}
                </td>
                <td data-label="Course Type">{student.courseType}</td>
                <td data-label="Status">{student.status ? '✔' : 'In Progress'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </>
);

export default GoalProgress;